export default function validateForm({ name, email, mobile, message }) {
  // Validate name
  if (!name) {
    return "Name required";
  }

  // Validate email using a regex pattern
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!email) {
    return "Email required";
  } else if (!emailRegex.test(email.toLowerCase())) {
    return "Email address is invalid";
  }

  // Validate mobile: check if provided, numeric and of a minimum length
  // if (!mobile) {
  //   return "Mobile is required";
  // } else if (!/^\d{10,}$/.test(mobile)) {
  //   return "Mobile must be a valid number";
  // } else if (mobile.length < 6) {
  //   return "Mobile needs to be 6 characters or more";
  // }
  return null;
}
